<template>
  <div class="hello">
    <div class="header">
      <div class="w1200 clearfix">
        <div class="header_l">
          欢迎光临志鹏供应链<em><img src="../assets/images/zp_01.png">&ensp;400-040-7890</em>
        </div>
        <div class="header_r">
          <router-link :to="{path:'/TaskAllocation'}" class="wddd_msgbtn">
            <span class="nav-icon-badge" v-if="MassageCount">{{MassageCount}}</span>
          </router-link>
          <router-link class="service_btn" :to="{path:'/Service'}" title="在线客服" target="_blank"><i class="el-icon-service"></i> 在线客服</router-link>
          <a href="javascript:;" class="ewm_btn">手机版<em><img src="../assets/images/qr000.png" alt=""></em></a>
          <em v-if="!current_user.id">
            <router-link :to="{path:'/Login',query: {return_url: return_url}}" class="login_btn">登录</router-link>
            <router-link :to="{path:'/Register'}" class="register_btn">注册</router-link>
          </em>
          <em v-else>
            <router-link :to="{path:'/MyOrder'}" class="wddd_btn">我的订单</router-link>
            <a href="javascript:;" class="login_btn" @click="logout">退出</a>
            <router-link :to="{path:'/MyOrder'}" style="color:#76a9f6;">欢迎-{{current_user.name || current_user.tel}}</router-link>
          </em>
        </div>
      </div>
    </div>
    <!-- search -->
    <div class="header_search clearfix w1200">
      <a href="/" target="_blank" title="志鹏供应链（内蒙古）有限公司" class="header_search_l">
        <img src="../assets/images/zpj_08.png">
      </a>
      <div class="header_search_c">
        <!-- <div class="header_search_ct clearfix">
          <span><input type="text" keywords placeholder="请输入产品名称 型号 SKU号" value="" maxlength="80"></span>
          <a href="javascript:;" search>搜索</a>
        </div> -->
        <el-autocomplete
          class="inline-input"
          :class="isActive?'searchStyle':'searchGray'"
          :clearable="true"
          v-model="searchMsg"
          :fetch-suggestions="querySearch"
          placeholder="请输入内容"
          :trigger-on-focus="false"
          @select="handleSelect"
          @keyup.enter.native="mySearch"
          @blur="blur"
          @focus="focus"
        >
          <!-- <i
            class="el-icon-camera-solid el-input__icon"
            slot="suffix"
            @click="handleIconClick">
          </i> -->
          <el-select v-model="searchType" slot="prepend" placeholder="请选择">
            <el-option label="标题" value="1"></el-option>
            <el-option label="代码" value="2"></el-option>
          </el-select>
          <el-button slot="append" icon="el-icon-search" @click="mySearch">搜索</el-button>
        </el-autocomplete>
        <!-- <el-input placeholder="请输入内容" v-model="searchMsg" class="input-with-select" :class="isActive?'searchStyle':'searchGray'" :clearable="true" @keyup.enter.native="mySearch" @blur="blur" @focus="focus">
          <el-select v-model="searchType" slot="prepend" placeholder="请选择">
            <el-option label="标题" value="1"></el-option>
            <el-option label="代码" value="2"></el-option>
          </el-select>
          <el-button slot="append" icon="el-icon-search" @click="mySearch"></el-button>
        </el-input> -->
        <div class="header_search_cb">
          <a href="javascript:;" v-for="(item,index) in keywords" :key="index" >
            <em @click="searchKwywords(item.title)" style="color:#c3bdba;">{{item.title}}</em>
          </a>
        </div>
      </div>
      <div class="header_search_r">
        <router-link :to="{path:'/Cart'}">
          <img src="../assets/images/zp_07.png"> 购物车 <em class="red" v-if="cartCount">{{cartCount}}</em>
        </router-link>
      </div>
      <div class="header_placeorder_r">
        <router-link :to="{path:'/Faster?id=3'}">
          <i class="el-icon-document-copy"></i> 快速下单
        </router-link>
      </div>
    </div>
    <div v-if="GoTopShow" class="fixed-base-wrap">
      <div class="fixed-header-container">
        <div class="nav-top">
          <div class="search-logo-nav">
            <a class="nav-top-images" href="/">
              <img src="../assets/images/zpj_08.png">
            </a>
          </div>
          <div class="search-wrap">
            <div class="search-box">
              <el-autocomplete
                class="inline-input"
                :class="isActive?'searchStyle':'searchGray'"
                :clearable="true"
                v-model="searchMsg"
                :fetch-suggestions="querySearch"
                placeholder="请输入内容"
                :trigger-on-focus="false"
                @select="handleSelect"
                @keyup.enter.native="mySearch"
                @blur="blur"
                @focus="focus"
              >
                <el-select v-model="searchType" slot="prepend" placeholder="请选择">
                  <el-option label="标题" value="1"></el-option>
                  <el-option label="代码" value="2"></el-option>
                </el-select>
                <el-button slot="append" icon="el-icon-search" @click="mySearch">搜索</el-button>
              </el-autocomplete>
              <!-- <el-input placeholder="请输入内容" v-model="searchMsg" class="input-with-select" :class="isActive?'searchStyle':'searchGray'" :clearable="true" @keyup.enter.native="mySearch" @blur="blur" @focus="focus">
                <el-select v-model="searchType" slot="prepend" placeholder="请选择">
                  <el-option label="标题" value="1"></el-option>
                  <el-option label="代码" value="2"></el-option>
                </el-select>
                <el-button slot="append" icon="el-icon-search" @click="mySearch"></el-button>
              </el-input> -->
            </div>
          </div>
          <div v-if="!current_user.id" class="clearfix btn-list">
            <router-link :to="{path:'/Register'}" class="floatLeft float-btn active">注册</router-link>
            <router-link :to="{path:'/Login',query: {return_url: return_url}}" class="floatLeft float-btn">登录</router-link>
          </div>
        </div>
      </div>
    </div>
    <div v-if="return_url !== '/Service'" class="layout-right-bar">
      <div class="ehsy-sidebar">
          <div class="ehsy-sidebar-tabs">
              <div v-if="!current_user.id" class="side-item">
                  <div>
                      <router-link :to="{path:'/Login'}">
                          <i class="icon-right-bar el-icon-user"></i>
                          <p class="sidebar-item-des">登录</p>
                      </router-link>
                  </div>
              </div>
              <div v-else class="side-item">
                  <div>
                    <router-link :to="{path:'/MyOrder'}">
                      <i class="icon-right-bar el-icon-tickets"></i>
                      <p class="sidebar-item-des">订单</p>
                    </router-link>
                  </div>
              </div>
              <div class="side-item">
                  <div>
                    <router-link :to="{path:'/Cart'}">
                      <i class="icon-right-bar el-icon-shopping-cart-full"></i>
                      <p class="sidebar-item-des">购物车</p>
                    </router-link>
                  </div>
              </div>
              <div class="side-item">
                  <div>
                    <router-link :to="{path:'/Placeorder'}">
                      <i class="icon-right-bar el-icon-notebook-1"></i>
                      <p class="sidebar-item-des">帮助</p>
                    </router-link>
                  </div>
              </div>
              <div class="side-item">
                  <div @click="lemonshow = true">
                    <i class="icon-right-bar el-icon-service"></i>
                    <p class="sidebar-item-des">客服</p>
                  </div>
              </div>
              <div v-if="GoTopShow" class="side-item" style="margin-top:200px">
                  <div @click="toTop">
                    <i class="icon-right-bar el-icon-top"></i>
                    <p class="sidebar-item-des">顶部</p>
                  </div>
              </div>
          </div>
      </div>
    </div>
    <div v-show="lemonshow" class="lemon-right">
      <lemon-imui
          width="300px"
          height="500px"
          simple
          :user="user"
          ref="IMUI"
          :avatar-cricle="true"
          @pull-messages="pullMessages"
          @message-click="messageClick"
          @send="send"
        >
        <template #message-title="contact">
          <span>{{ contact.displayName }}</span>
          <b><i @click="lemonshow = false" class="el-icon-minus" title="关闭"></i></b>
        </template>
      </lemon-imui>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api/service'
import Cookies from 'js-cookie'
const getTime = () => new Date().getTime()
const generateRandId = () => Math.random().toString(36).substr(-8)
var tourid = ''
if (Cookies.get('tourid')) {
  tourid = Cookies.get('tourid')
} else {
  tourid = Cookies.set('tourid', generateRandId())
}

export default {
  name: 'Header',
  props: ['esSearch'], // vue不推荐直接在子组件中修改父组件传来的props的值，会报错
  data () {
    return {
      return_url: this.$route.fullPath,
      searchType: '1',
      searchMsg: this.esSearch, // 通过data, 定义新变量searchMsg, 这样searchMsg的值变更时，不会影响父组件传来的esSearch的值
      isActive: false,
      lemonshow: false,
      user: {
        id: tourid,
        displayName: '游客',
        avatar: 'https://serv.nmzp.com/uploads/1/image/20220711/7d3cfc5335c051082f6ac6cccce9ebc1.png'
      },
      scroll: '', // 页面滚动的高度
      GoTopShow: false // 是否显示
    }
  },
  created () {
    var that = this
    this.ws = new WebSocket('wss://serv.nmzp.com/wss')
    this.ws.onopen = function () {
      console.log('连接成功')
      that.ws.send(JSON.stringify({type: 'bind', uid: that.user.id, mode: 'bind'}))
      window.setInterval(function () {
        console.log('连接成功')
        that.ws.send(JSON.stringify({type: 'bind', uid: that.user.id, mode: 'bind'}))
      }, 30000)
    }
    this.ws.onclose = function () {
      console.log('关闭了')
    }
    this.ws.onmessage = function (e) {
      const { IMUI } = that.$refs
      var data = JSON.parse(e.data)
      console.log(data)
      var result = {
        id: data.id,
        status: 'succeed',
        type: data.type,
        sendTime: data.sendTime,
        content: data.content,
        toContactId: data.fromUser.id,
        mode: data.mode,
        fileSize: data.fileSize,
        fileName: data.fileName,
        fromUser: {
          id: data.fromUser.id,
          displayName: data.fromUser.displayName,
          avatar: data.fromUser.avatar
        }
      }
      setTimeout(() => {
        if (data.toContactId !== data.fromUser.id) {
          IMUI.appendMessage(result, true)
        }
      }, 50)
    }
  },
  computed: {
    ...mapGetters([
      'current_user',
      'cartCount',
      'keywords',
      'MassageCount'
    ])
  },
  watch: {
    scroll: function () {
      if (this.scroll > 500) {
        this.GoTopShow = true
      } else {
        this.GoTopShow = false
      }
    }
  },
  mounted () {
    if (this.current_user.id) {
      this.$store.dispatch('cart/getCartCount')
      this.$store.dispatch('cart/getMassageCount')
    }
    this.$store.dispatch('cart/getSearchKeywords')
    const { IMUI } = this.$refs
    if (this.return_url.substring(0, 16) === '/GoodsDetail?id=') {
      IMUI.initEditorTools([
        {
          name: 'uploadImage'
        },
        {
          name: 'test',
          click: () => {
            var url = 'https://www.nmzp.com/#' + this.return_url
            IMUI.setEditorValue(url)
          },
          render: () => {
            return <span>当前产品</span>
          }
        }
      ])
    } else {
      IMUI.initEditorTools([
        {
          name: 'uploadImage'
        }
      ])
    }
    IMUI.initContacts([
      {
        id: 71,
        displayName: '小鹏家',
        avatar: 'https://serv.nmzp.com/uploads/1/image/20220711/558c0cee2b13c6f488f522c1ce7bb8fe.png',
        type: 'tourist',
        index: 'T',
        unread: 0,
        lastSendTime: getTime(),
        lastContent: ''
      }
    ])
    setTimeout(() => {
      IMUI.changeContact(71)
    }, 2000)
    window.addEventListener('scroll', this.handleScroll, true)
  },
  methods: {
    async logout () {
      await this.$store.dispatch('user/logout')
      if (this.$route.path !== '/') {
        this.$router.push({ path: '/' })
      }
    },
    mySearch () {
      if (!this.searchMsg) {
        this.$message.error('请输入要搜索的产品名称或产品代码')
        return false
      }
      if (this.searchMsg && this.searchType === '1') {
        this.$router.push({name: 'Search', query: {keywords: this.searchMsg, searchType: this.searchType}})
      } else {
        this.$router.push({name: 'GoodsDetail', query: {sku: this.searchMsg}})
      }
    },
    searchKwywords (title) {
      this.$router.push({name: 'Search', query: {keywords: title, searchType: 1}})
    },
    blur () {
      this.isActive = false
    },
    focus () {
      this.isActive = true
    },
    messageClick (e, key, message) {
      const { IMUI } = this.$refs
      if (key === 'status') {
        IMUI.updateMessage({
          id: message.id,
          toContactId: message.toContactId,
          status: 'going',
          content: '重新发送消息...'
        })
        setTimeout(() => {
          IMUI.updateMessage({
            id: message.id,
            toContactId: message.toContactId,
            status: 'succeed',
            content: '发送成功'
          })
        }, 2000)
      }
    },
    send (message, next, file) {
      console.log(message)
      if (message['content'] === '') {
        this.$message({
          message: '内容不能为空',
          type: 'warning'
        })
        return false
      }
      message['mode'] = 'tourist'
      if (file) {
        var suffix = file.name.split('.')[file.name.split('.').length - 1]
        if (suffix !== 'jpg' && suffix !== 'gif' && suffix !== 'jpeg' && suffix !== 'png' && suffix !== 'mp3' && suffix !== 'mp4' && suffix !== 'xls' && suffix !== 'xlsx' && suffix !== 'doc' && suffix !== 'docx' && suffix !== 'txt') {
          this.$message({
            message: '此文件不允许上传',
            type: 'warning'
          })
          return false
        }
        const formData = new FormData()
        formData.append('file', file)
        api.ChatUpload(formData).then((response) => {
          if (response.code === 20000) {
            message['content'] = response.message
            this.ws.send(JSON.stringify(message))
          }
        })
      } else {
        this.ws.send(JSON.stringify(message))
      }
      setTimeout(() => {
        next()
      }, 10)
    },
    pullMessages (contact, next) {
      const { currentContactId } = this.$refs.IMUI
      const otherUser = {
        id: contact.id,
        avatar: contact.avatar,
        displayName: contact.displayName
      }
      const mess = (content, fromUser = this.user) => {
        return {
          id: generateRandId(),
          status: 'succeed',
          type: 'text',
          sendTime: getTime(),
          content,
          toContactId: currentContactId,
          fromUser
        }
      }
      const message = (messageList, fromUser = this.user) => {
        return {
          id: messageList.id,
          status: 'succeed',
          type: messageList.filetype,
          sendTime: parseInt(messageList.time),
          content: messageList.content,
          fileSize: parseInt(messageList.filesize),
          fileName: messageList.filename,
          toContactId: currentContactId,
          fromUser
        }
      }
      const messages = [
        mess('欢迎访问志鹏工业品采购平台，欢迎前来咨询选购！', otherUser)
      ]
      // 聊天数据
      var messageLists = []
      api.getChattourlist({'uid': this.user.id, 'sid': contact.id}).then((response) => {
        if (response.code === 20000) {
          messageLists = response.items
          if (messageLists.length > 0) {
            for (var i = 0; i < messageLists.length; i++) {
              if (messageLists[i]['uid'] === this.user.id) {
                messages.push(message(messageLists[i]))
              } else if (messageLists[i]['uid'] === contact.id) {
                messages.push(message(messageLists[i], otherUser))
              }
            }
          }
          setTimeout(() => {
            next(messages, true)
          }, 1000)
        } else {
          messageLists = []
        }
      })
    },
    handleScroll () {
      this.scroll = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset
    },
    toTop () {
      this.toTopSpeed = setInterval(() => {
        document.documentElement.scrollTop = document.documentElement.scrollTop - 20
        // 通过改变数字实现动画延迟滚动
        if (this.scroll < 10) {
          clearInterval(this.toTopSpeed)
        }
      }, 1)
    },
    querySearch (queryString, cb) {
      let results = []
      if (queryString === '') {
        this.restaurants = [{ value: '暂无匹配信息' }]
        cb(this.restaurants)
      } else {
        api.SearchSelect({ 'search': queryString }).then(response => {
          this.restaurants = response.items.suggestions
          results = this.restaurants.map(x => ({ ...x, value: x.suggestion }))
          if (results.length > 0) {
            cb(results)
          } else {
            this.restaurants = [{ value: '暂无匹配信息' }]
            cb(this.restaurants)
          }
        })
      }
    },
    handleSelect (item) {
      this.searchMsg = item.suggestion
      this.mySearch()
    },
    handleIconClick (ev) {
      console.log(ev)
    }
  }
}
</script>

<!-- 添加“scoped”属性来限制CSS只适用于此组件 -->
<style scoped>
  .el-select{
    width: 80px!important;
  }
  .input-with-select .el-input-group__prepend {
    background-color: #fff;
  }
  ::v-deep.searchStyle .el-input__inner{
    color:#606266;
  }
  ::v-deep.searchGray .el-input__inner{
    color:rgb(195, 189, 186)
  }
  .el-input__icon {
    font-size: 25px;
  }
  /* 右侧导航 */
    .layout-right-bar {
        height: 100%;
        margin: 0;
        padding: 0;
        position: fixed;
        right: 0;
        top: 0;
        width: 0;
        z-index: 999;
    }
    .layout-right-bar .ehsy-sidebar {
        background-color: #5178b5;
        height: 100%;
        position: absolute;
        right: 0;
        top: 0;
        width: 4px;
        z-index: 999;
    }
    .layout-right-bar .ehsy-sidebar-tabs {
        margin-top: -76px;
        position: absolute;
        right: 0;
        top: 50%;
    }
    .layout-right-bar .ehsy-sidebar-tabs > div {
        background-color: #5178b5;
        border-radius: 4px;
        height: 47px;
        margin-bottom: 2px;
        position: relative;
        width: 40px;
        border-radius: 4px 0px 0px 4px;
    }
    .layout-right-bar .ehsy-sidebar-tabs > div:hover {
        background-color: #5c99f5;
    }
    .side-item {
        background: #fff;
        box-shadow: -2px 0 5px 0 rgb(43 43 62 / 6%);
        border-radius: 3px 0 0 3px;
        cursor: pointer;
    }
    .layout-right-bar .ehsy-sidebar-tabs > div div {
        height: 36px;
        left: 0;
        position: absolute;
        width: 36px;
    }
    .layout-right-bar .ehsy-sidebar i {
        display: block;
        margin: 6px auto;
        max-width: 24px;
        cursor: pointer;
    }
    .layout-right-bar .icon-rb-account {
        background-position: 0 0;
    }
    .layout-right-bar .icon-right-bar {
        color: #FFFFFF;
        height: 23px;
        width: 24px;
        font-size: 22px;
        padding-left: 6px;
    }
    .layout-right-bar .ehsy-sidebar .sidebar-item-des {
        width: 40px;
        height: 15px;
        font-size: 12px;
        color: #FFFFFF;
        line-height: 15px;
        margin-top: -5px;
        text-align: center;
    }
    .lemon-right {
      position: fixed;
      bottom: 0;
      right: 45px;
      z-index: 999;
    }
    .lemon-container__title b{
      padding-left: 200px;
    }
    .lemon-container__title i{
      cursor: pointer;
      font-size: 18px;
    }
    .el-icon-document-copy {
      font-size: 18px;
      color: #fff;
      padding-right: 2px;
    }
    .el-autocomplete {
      width: 100%;
    }
    /* 右侧导航 */
    /* 吸顶导航 */
    .fixed-base-wrap {
      top: 0;
      width: 100%;
      position: fixed;
      z-index: 2000;
    }
    .fixed-header-container {
      position: absolute;
      top: 0;
      height: 64px;
      width: 100%;
      background: #fff;
      -webkit-box-shadow: 0 0 20px#999;
    }
    .fixed-header-container .nav-top {
      width: 1200px;
      height: 100%;
      margin: 0 auto;
      position: relative;
    }
    .fixed-header-container .nav-top .search-logo-nav {
      left: 0;
      margin: auto;
      top: 0;
      bottom: 0;
      height: 64px;
      display: inline-block;
      width: 242px;
      margin-right: 10px;
    }
    .fixed-header-container .nav-top .search-wrap {
      left: 242px;
      right: 0;
      top: 0;
      bottom: 0;
      width: 716px;
      height: 40px;
      padding: 12px 0;
    }
    .fixed-header-container .nav-top>* {
      position: absolute;
    }
    .fixed-header-container .nav-top .search-wrap .search-box {
      width: 710px;
      height: 40px;
      background: #fff;
      border-radius: 5px;
      position: relative;
      margin-left: 20px;
    }
    .fixed-header-container .nav-top .btn-list {
      width: 240px;
      right: 0;
      margin: auto;
      top: 0;
      bottom: 0;
      height: 28px;
    }
    .fixed-header-container .nav-top .btn-list a.active {
      color: #fff;
      border: 1px solid #fff;
      margin-left: 88px;
    }
    .fixed-header-container .nav-top .btn-list a {
      width: 64px;
      height: 32px;
      background: #2c3038;
      border-radius: 5px;
      line-height: 32px;
      text-align: center;
      margin-left: 20px;
      color: #fff;
      border: 1px solid #999999;
    }
    .fixed-header-container .nav-top .btn-list a.active:hover {
      background: #07357b;
      border: 1px solid #fff;
      color: #fff;
    }
    .fixed-header-container .nav-top .btn-list a:hover {
      background: #999999;
      border: 1px solid #999999;
      color: #fff;
    }
    .floatLeft {
      float: left;
    }
    /* 吸顶导航 */
    .header_search_c .el-button {
      background: #5178b5;
      font-size: 15.5px;
      font-weight: 700;
      color: #fff;
    }
    .search-box .el-button {
      background: #5178b5;
      font-size: 15.5px;
      font-weight: 700;
      color: #fff;
    }
    .nav-icon-badge{
      font-size: 11px;
      padding: 0 5px;
      background-color: #f7261c;
      transform: translate(-50%,-40%);
      color: #fff;
      border-radius: 100px;
      position: relative;
      bottom: -3px;
      left: -9px;
    }
</style>
<style>
.lemon-container__title {
  border-bottom: 1px solid #ddd;
}
.lemon-editor__tool {
  border-top: 1px solid #ddd;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue